import {
  readFilterStateWithFilterKey,
  saveFilterStateRouteView,
} from "../../util/Util";
import { ROUTE_FILTER_STATE_KEY } from "../utils/LocalStoragekeys";
import {
  SELECT_PRODUCT_TYPE,
  SELECT_ROUTE_SPEED,
  RECEIVE_FILTER_DATA,
  SELECT_CLUSTER,
  SELECT_DRIVER_TYPE,
  SELECT_STATUS,
  SELECT_DEPARTURE,
  SELECT_VIEW_TYPE,
  UNLOAD_VIEW,
  REMOVE_ALL_FILTER,
  REMOVE_FILTER,
  SELECT_STAGE_LOCATION_TYPE,
  LOAD_FILTERS,
} from "../utils/ReducerActionTypes";

export const RouteFilterReducer = (state, action) => {
  switch (action.type) {
    case SELECT_PRODUCT_TYPE: {
      const newState = { ...state, productType: action.productType };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case SELECT_ROUTE_SPEED: {
      const newState = { ...state, deliverySpeed: action.deliverySpeed };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case RECEIVE_FILTER_DATA: {
      const newState = { ...state, data: { ...state.data, ...action.data } };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case SELECT_CLUSTER: {
      const newState = { ...state, cluster: action.cluster };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case SELECT_DRIVER_TYPE: {
      const newState = { ...state, driverType: action.driverType };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case SELECT_STATUS: {
      const newState = { ...state, status: action.status };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case SELECT_DEPARTURE: {
      const newState = { ...state, departure: action.departure };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case SELECT_VIEW_TYPE: {
      const newState = { ...state, viewType: action.viewType };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case UNLOAD_VIEW:
      return state;
    case REMOVE_ALL_FILTER: {
      const newState = { ...state };
      Object.entries(state).forEach((entry) => {
        const key = entry[0];
        const values = entry[1];
        if (Array.isArray(values) && values.length && key !== "data") {
          newState[key] = [];
        }
      });
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case REMOVE_FILTER: {
      const { key, value } = action.data;
      state[key] = state[key].filter((item) => item !== value);
      const newItem = state[key].filter((item) => item !== value);
      const newState = { ...state, [key]: newItem };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case SELECT_STAGE_LOCATION_TYPE: {
      const newState = {
        ...state,
        stageLocationType: action.stageLocationType,
      };
      saveFilterStateRouteView(ROUTE_FILTER_STATE_KEY, newState);
      return newState;
    }
    case LOAD_FILTERS: {
      const savedState = readFilterStateWithFilterKey(ROUTE_FILTER_STATE_KEY);
      if (savedState) {
        return {
          ...state,
          ...savedState,
        };
      }
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/RouteStatus/reducers/RouteFilterReducer.js